import { useMutation, useQueryClient, UseMutationOptions } from "@tanstack/react-query";

import { Content } from "@/types";
import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface EditPlaygroundSessionChatMessageRequestI {
  content: Content[];
}

export interface EditPlaygroundSessionChatMessageResponseI {
  success: boolean;
  message_id: string;
  content: Content[];
}

export interface EditPlaygroundSessionChatMessageParamsI {
  workspaceId: number;
  sessionId: string;
  messageId: string;
  request: EditPlaygroundSessionChatMessageRequestI;
}

export const useAPIEditPlaygroundSessionChatMessage = (
  userToken: string,
  options?: UseMutationOptions<
    EditPlaygroundSessionChatMessageResponseI,
    Error,
    EditPlaygroundSessionChatMessageParamsI
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    EditPlaygroundSessionChatMessageResponseI,
    Error,
    EditPlaygroundSessionChatMessageParamsI
  >(
    variables =>
      fetch(
        ENDPOINTS.playground_session_chat_message(
          variables.workspaceId,
          variables.sessionId,
          variables.messageId,
        ),
        {
          method: "PATCH",
          headers: jsonAuthHeaders(userToken),
          body: JSON.stringify(variables.request),
        },
      ).then(handleResponse),
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([
          "playground-session-chat-messages",
          variables.workspaceId,
          variables.sessionId,
        ]);
      },
      ...options,
    },
  );
};
